/**
 * Komissiya (2026-10-25): foiz kategoriyadan (sozlama `commission_rates`) yoki formada qo'lda; faqat foiz. Daftarda bitta qator --
 * kirimda hisobga net (asosiy - komissiya), chiqimda asosiy + komissiya. Aniq summa serverda (finance.services.apply_commission),
 * bu yerda faqat oldindan ko'rsatish uchun, xuddi shu yaxlitlash bilan (test: commission.test.ts).
 */
import type { Direction } from "./types";

export interface CommissionRates {
  in: Record<string, number>;
  out: Record<string, number>;
}

const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

/** Kategoriyaning foizi formaga ("" -- yo'q) */
export function categoryRate(rates: CommissionRates | undefined, direction: Direction, category: string): string {
  const value = category ? rates?.[direction]?.[category] : undefined;
  return value && value > 0 ? String(value) : "";
}

/** Formadagi foiz: "" yoki 0 -- komissiyasiz (to'g'ri), 0..99.99 oralig'idan tashqari -- xato */
export function pctError(value: string): boolean {
  if (value.trim() === "") return false;
  const n = Number(value);
  return !Number.isFinite(n) || n < 0 || n >= 100;
}

/** Hisobga ta'sir qiladigan net summa va komissiya; foiz yo'q yoki noto'g'ri -- komissiyasiz */
export function withCommission(direction: Direction, amount: number, pct: string): { net: number; fee: number } {
  const p = pctError(pct) ? 0 : Number(pct || 0);
  if (!p || !amount) return { net: amount, fee: 0 };
  const fee = round2((amount * p) / 100);
  return { net: round2(direction === "in" ? amount - fee : amount + fee), fee };
}
